import { render, staticRenderFns } from "./orderPie.vue?vue&type=template&id=6fc02707&scoped=true&"
import script from "./orderPie.vue?vue&type=script&lang=js&"
export * from "./orderPie.vue?vue&type=script&lang=js&"
import style0 from "./orderPie.vue?vue&type=style&index=0&id=6fc02707&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc02707",
  null
  
)

export default component.exports